<template>
  <!-- 팬 공간 전용 사이드바. 스트리머용 TheLeftBar와 완전 분리(펫/재화 등 스트리머 요소 없음). -->
  <v-navigation-drawer class="elevation-14" app permanent width="240">
    <div class="fan-nav__header d-flex align-center px-4 py-4">
      <span class="text-h6">🎉</span>
      <span class="ml-2 font-weight-bold" style="font-family: maplestory; font-size: 18px">팬 공간</span>
    </div>

    <v-divider></v-divider>

    <v-list dense shaped>
      <v-list-item v-for="item in items" :key="item.to" link :to="item.to" exact>
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="font-size: 16px">{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template #append>
      <v-divider></v-divider>
      <div class="pa-3">
        <!-- 로컬 전용: 스트리머 공간으로 바로 전환 (개발 편의) -->
        <v-btn v-if="isLocalEnv" text block small color="primary" class="mb-1" @click="goStreamer">
          <v-icon left small>mdi-swap-horizontal</v-icon>스트리머로 전환 (local)
        </v-btn>
        <v-btn text block small @click="showLogoutDialog = true">
          <v-icon left small>mdi-logout</v-icon>{{ $t("nav.logout") }}
        </v-btn>
      </div>
    </template>

    <!-- 로그아웃 확인 다이얼로그 (스트리머 UtilityBar와 동일) -->
    <base-dialog v-model="showLogoutDialog" :title="$t('nav.logoutConfirmTitle')">
      {{ $t("nav.logoutConfirmBody") }}
      <template #actions>
        <v-btn text @click="showLogoutDialog = false">{{ $t("common.cancel") }}</v-btn>
        <v-btn color="primary" text @click="onClickLogout">{{ $t("nav.logout") }}</v-btn>
      </template>
    </base-dialog>
  </v-navigation-drawer>
</template>

<script>
import { FAN_NAV_CATEGORIES } from "@/constants/navMenu";
import { supabase } from "@/utils/supabase";
import { isLocal } from "@/utils/env-utils";
import BaseDialog from "@/components/BaseDialog.vue";

export default {
  name: "TheFanLeftBar",
  components: { BaseDialog },
  data() {
    return { items: FAN_NAV_CATEGORIES, showLogoutDialog: false };
  },
  computed: {
    isLocalEnv() {
      return isLocal();
    },
  },
  methods: {
    // 로컬 전용: 스트리머 공간으로 전환 — 리로드 없이 store 즉시 갱신(사이드바 반응) + 라우팅
    goStreamer() {
      localStorage.setItem("auth/role", "streamer");
      this.$store.commit("__setIsFan", false);
      this.$router.push("/home").catch(() => {});
    },
    // 로그아웃 — 스트리머(UtilityBar.onClickLogout)와 동일
    async onClickLogout() {
      await supabase.auth.signOut();
      localStorage.clear();
      this.$store.commit("__setIsFan", false);
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.fan-nav__header {
  min-height: 56px;
}
</style>
